import React from 'react'
import { Box } from "@mui/material"

import { REPORT_STATUS } from "@constants"
import ReportHomeListTableRunningBlock from "Pages/Main/Home/ReportsTable/columns/date/RunningBlock"
import ReportHomeListTableStoppedBlock from "Pages/Main/Home/ReportsTable/columns/date/StoppedBlock"
import ReportHomeListTableReadyBlock from "Pages/Main/Home/ReportsTable/columns/date/ReadyBlock"


export default function dateColumn() {

	return {
		name: "timestampLastExecutionUser",
		label: "Date",
		render: (value, rowData) => <Box
			sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
			{rowData.statusLastExecution === REPORT_STATUS.READY && <ReportHomeListTableReadyBlock
				date={value}
				reportExecutionID={rowData.idLastExecution}
				officeID={rowData.idOfficePickup[0]}
				hasCompetitionSites={rowData.hasCompetitionSites}
				hasDirectSites={rowData.hasDirectSites}
				pickUp={rowData.pickUp}
				noResults={rowData.allExecutionsNoResults}
				hasExport={rowData.export}
				hasGenerate={rowData.generate}
			/>}
			{rowData.statusLastExecution === REPORT_STATUS.RUNNING &&
				<ReportHomeListTableRunningBlock rowData={rowData}/>}
			{rowData.statusLastExecution === REPORT_STATUS.STOPPED &&
				<ReportHomeListTableStoppedBlock date={value}/>}
		</Box>
	}
}